import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import HistoryOutlinedIcon from '@material-ui/icons/HistoryOutlined';

class LocationHistoryButtons extends Component {
  static availableOptions = [
    {
      label: '1H',
      value: 1,
      unit: 'hour',
    },
    {
      label: '1D',
      value: 1,
      unit: 'day',
    },
    {
      label: '3D',
      value: 3,
      unit: 'day',
    },
    {
      label: '...',
      value: 0,
      unit: 'day',
    },
  ];

  state = {
    showOptions: false,
  }

  toggleShowOptions = () => {
    this.setState(prevState => ({
      showOptions: !prevState.showOptions,
    }));
  }

  renderOptionButtons = () => LocationHistoryButtons.availableOptions.map(
    (option, ix, arr) => this.renderOptionButton(
      ix,
      arr.length,
      option,
      this.props.selectedOption === option.label,
      () => this.onOptionSelected(option),
    ),
  );

  // ix and length args are needed to calculate a transition delay based on the 
  // options position in a panel. Adds a nice animation effect.
  renderOptionButton = (ix, length, option, isSelected, onClick) => {
    const classes = clsx({
      'map-btn': true,
      'map-btn--selected': isSelected,
    });

    const delay = this.state.showOptions ? `${30 + (length-ix)*30}ms` : `${30 + (ix * 30)}ms`

    return (
      <a id={`mapLocHistoryBtn-${option.label}`}
        key={option.label}
        className={classes}
        style={ { transitionDelay: delay } }
        onClick={onClick}>
          {option.label}
      </a>
    );
  }

  onOptionSelected = (option) => {
    this.setState({
      showOptions: false,
    });

    this.props.onOptionSelect(option);
  }

  render() {
    const rootButtonClasses = clsx({
      'map-btn': true,
      'map-btn--selected': this.state.showOptions || this.props.selected,
    });

    const asideClasses = clsx({
      'map-btn-hpanel': true,
      'map-btn-hpanel--aside': true,
      'map-btn-hpanel--aside--visible': this.state.showOptions,
    });

    return (
      <div className="map-btn-hpanel">
        <a id="mapLocHistoryToogleBtn" className={rootButtonClasses}
          onClick={this.toggleShowOptions}>
            <HistoryOutlinedIcon />
            {this.props.selectedOption ? (
              <div className="map-btn--badge">{this.props.selectedOption}</div>
            ) : null}
        </a>

        <div className={asideClasses}
          style={ { pointerEvents: this.state.showOptions ? 'auto' : 'none' } }>
          {this.renderOptionButtons()}
        </div>
      </div>
    );
  }
}

LocationHistoryButtons.propTypes = {
  selected: PropTypes.bool,
  onOptionSelect: PropTypes.func.isRequired,
};

export default LocationHistoryButtons;
